<template>
  <div class="pl-2 pr-2">
    <div id="gantt-header" class="h-12 p-2 flex items-center gap-2">
      <h1 class="text-xl font-bold" style="margin-right: 10px;">KERP Time Gantt</h1>
      <button @click="addTask" class="bg-indigo-700 hover:bg-indigo-900 text-white py-2 px-4 rounded-lg flex items-center">
        <svg class="w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        <span class="font-bold text-xs">作業予定・実績追加</span>
      </button>
      <div class="flex items-center">
        <button class="bg-blue-200 hover:bg-blue-300 text-black py-1 px-4 rounded-lg flex items-center"
          @click="prevDate"
        >
          前日
        </button>
        <button class="bg-blue-200 hover:bg-blue-300 text-black py-1 px-4 rounded-lg flex items-center ml-1"
          @click="nextDate"
        >
          翌日
        </button>
        <button class="bg-blue-200 hover:bg-blue-300 text-black py-1 px-4 rounded-lg flex items-center ml-1"
                @click="goToGanttChartHome"
        >
          戻る
        </button>

        <div class="ml-2 flex items-center">
          <span>カテゴリ: </span>
          <input type="text" class="text-xs border rounded-lg px-4 py-2 field-width cursor-pointer"
                 @click="openBillDialog" v-model="selectedCategoryName"
                 placeholder="ここをクリック"
                 readonly>
        </div>
      </div>

      <CTimeEditForm
          :showDialog="showDialog"
          :update_mode="update_mode"
          :form="form"
          :errors="errors"
          :apiErrorMsg="apiErrorMsg"
          :loading="loading"
          :billsList="billsList"
          :billsListAll="billsListAll"
          :usersList="usersList"
          :greencTasksList="greencTasksList"
          :greenc-mst-status-types-list="greenc_mst_status_typesList"
          :greenc_child_task_work_typeList="greenc_child_task_work_typeList"
          :work_typesList="work_typesList"
          :work_time_typesList="work_time_typesList"
          @save="saveTask"
          @update="updateTask"
          @delete="deleteTask"
          @close="showDialog = false"
          @change="onFormChange"
      />
    </div>

    <div style="padding: 0 10px">
      <p v-if="apiErrorMsgForHome" style="color: #bf0000; font-size: 20px">{{apiErrorMsgForHome}}</p>
    </div>

    <CGanttChartTime
        :tasks-list="filteredTasks"
        :categories="categories"
        :clickable="true"
        :resizable="true"
        :draggable="true"
        :auto-scroll="false"
        :start-date="selectedStartDate"
        :block_size="40"
        :apply-filters="true"
        :users-list="usersList"
        :greencTasksList="greencTasksList"
        :greenc_child_task_work_typeList="greenc_child_task_work_typeList"
        :show-edit-dialog="showDialog"
        @editTask="editTask"
        @taskUpdated="updateDraggedTask"
    />

    <CCommonDialogComponent
        ref="ref_bills_list_dialog"
        :data="dialogData"
        :headers="dialogHeaders"
        @row-click="rowClick"
    />
  </div>
</template>

<script>
import CGanttChartTime from '@/components/CGanttChartTimeForHome.vue'
import CTimeEditForm from '@/components/CHomeTimeBasedGanttChartEditForm.vue'
import apiUrl from "@/const/apiUrl";
import config from "@/prm/Pgreencchildtasks"
import billsCnv from '@/util/Ubills'
import CCommonDialogComponent from "@/components/CCommonDialogComponent.vue";
import billsFields from '@/fields/bills'
// import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'HomeTimeBasedGanttChart',
  components: { CGanttChartTime, CTimeEditForm, CCommonDialogComponent },
  mixins: [billsCnv],
  data() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    return {
      actl: config.actl,
      aaction: config.aaction,
      saveUrl: config.saveAdd,
      editUrl: config.saveEdit,
      deleteUrl: config.saveDelete,
      selectedStartDate: null,
      tasks: [],
      categories: [],
      showDialog: false,
      form: {
        id: '',
        F1: '',
        greenc_task_id: null,
        greenc_child_task_work_type_id: null,
        greenc_child_task_work_type_name: '',
        work_type_id: null,
        work_time_type_id: null,
        bill_id: null,
        bill_name: null,
        user_id: null,
        task_date: todayStr,
        start_time: '',
        end_time: '',
      },
      update_mode: false,
      errors: {},
      apiErrorMsg: '',
      loading: false,
      apiErrorMsgForHome: '',
      nextId: 6,
      selectedItemId: null,
      billsList: [],
      billsListAll: [],
      usersList: [],
      greenc_mst_status_typesList: [],
      greencTasksList: [],
      greenc_child_task_work_typeList: [],
      work_typesList: [],
      work_time_typesList: [],
      selectedCategoryId: null,
      selectedCategoryName: '',
      dialogData: [],
      dialogHeaders: [],
      formatDate(date) {
        if (!date) return ''
        // format as YYYY-MM-DD
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
    }
  },
  mounted() {
    this.loadData()
    if("targetDate" in this.$route.params) {
      this.selectedStartDate = this.$route.params.targetDate
    }else {
      this.selectedStartDate = this.$moment().format('YYYY-MM-DD')
    }
  },
  computed: {
    filteredTasks() {
      if (!this.selectedStartDate) return this.tasks;
      return this.tasks.filter(task => {
        const taskDate = this.$moment(task.task_date).format('YYYY-MM-DD');
        if (this.selectedCategoryId) {
          return taskDate === this.selectedStartDate && task.category_id === this.selectedCategoryId
        }
        return taskDate === this.selectedStartDate;
      });
    }
  },
  methods: {
    rowClick(row) {
      this.selectedCategoryId = row.id;
      this.selectedCategoryName = row.name;
      this.$refs.ref_bills_list_dialog.closeDialog()
    },
    openBillDialog() {
      const billsData = [...this.billsListAll]
      const findIndex = billsData.findIndex(item => item.id === null)
      if (findIndex === -1) {
        billsData.unshift({
          id: null,
          name: 'すべて表示'
        })
      }
      this.dialogData = billsData
      this.dialogHeaders = this.extractViewFields(billsFields)
      this.$refs.ref_bills_list_dialog.openDialog()
    },
    extractViewFields(data) {
      return data.filter(item => item.view === true)
    },
    loadData() {
      this.resetData()
      const url = apiUrl + this.actl + '/' + this.aaction + '.json'
      this.$axios.get(url)
          .then(response => {
            console.log('response', response)
            if (response.status === 200) {
              if ( Object.prototype.hasOwnProperty.call(response.data, 'list')) {
                response.data.list.forEach(element => {
                  const task = this.prepareTaskData(element)
                  this.tasks.push(task)
                })
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'bills')) {
                const billsList = []
                const categoryList = []
                for (const id in response.data.bills) {
                  billsList.push({
                    id: id,
                    name: response.data.bills[id]
                  })
                  categoryList.push({
                    id: parseInt(id),
                    name: response.data.bills[id],
                    collapsed: false,
                  })
                }
                this.billsList = billsList
                this.categories = categoryList
              }

              const billsAllData = []
              for (const recordData of response.data.bills_all) {
                billsAllData.push(this.cnvData(recordData))
              }
              this.billsListAll = billsAllData

              if (Object.prototype.hasOwnProperty.call(response.data, 'greenc_tasks_all')) {
                const greencTasksList = []
                response.data.greenc_tasks_all.map(element => {
                  greencTasksList.push({
                    id: element.id,
                    name: element.F1,
                    bill_id: element.bill_id
                  })
                })
                this.greencTasksList = greencTasksList
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'users')) {
                const usersList = []
                for (const id in response.data.users) {
                  usersList.push({
                    id: id,
                    name: response.data.users[id]
                  })
                }
                this.usersList = usersList
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'greenc_mst_status_types')) {
                const greenc_mst_status_typesList = []
                for (const id in response.data.greenc_mst_status_types) {
                  greenc_mst_status_typesList.push({
                    id: id,
                    name: response.data.greenc_mst_status_types[id]
                  })
                }
                this.greenc_mst_status_typesList = greenc_mst_status_typesList
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'greenc_child_task_work_types')) {
                const greenc_child_task_work_type_list = []
                for (const id in response.data.greenc_child_task_work_types) {
                  greenc_child_task_work_type_list.push({
                    id: id,
                    name: response.data.greenc_child_task_work_types[id]
                  })
                }
                this.greenc_child_task_work_typeList = greenc_child_task_work_type_list
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'work_types')) {
                const listData = []
                for (const id in response.data.work_types) {
                  listData.push({
                    id: id,
                    name: response.data.work_types[id]
                  })
                }
                this.work_typesList = listData
              }

              if (Object.prototype.hasOwnProperty.call(response.data, 'work_time_types')) {
                const listData = []
                for (const id in response.data.work_time_types) {
                  listData.push({
                    id: id,
                    name: response.data.work_time_types[id]
                  })
                }
                this.work_time_typesList = listData
              }
            }
          })
          .catch(error => {
            console.log('error', error)
          })
    },
    resetData() {
      this.tasks = []
      this.billsList = []
      this.usersList = []
      this.greenc_mst_status_typesList = []
      this.greencTasksList = []
      this.greenc_child_task_work_typeList = []
      this.work_typesList = []
      this.work_time_typesList = []
    },
    onFormChange(payload) {
      const { field, value } = payload || {};
      if (!field) return;
      this.form = { ...this.form, [field]: value };
    },
    editTask(task) {
      this.update_mode = true;
      this.showDialog = true;
      this.form = { ...task };
      this.apiErrorMsg = '';
      this.errors = {};
    },
    addTask() {
      this.update_mode = false;
      this.form = {
        F1: '',
        greenc_task_id: null,
        task_date: this.selectedStartDate,
        start_time: this.roundTo15UsingMoment(this.$moment().format("HH:mm")),
        end_time: this.roundTo15UsingMoment(this.$moment().format("HH:mm")),
        bill_id: null,
        greenc_child_task_work_type_id: 1,
        greenc_child_task_work_type_name: '',
        work_type_id: 1,
        work_time_type_id: 1,
        bill_name: '',
        user_id: null,
        greenc_mst_status_type_id: null,
      };
      this.showDialog = true;
      this.apiErrorMsg = '';
      this.errors = {};
    },
    roundTo15UsingMoment(timeStr) {
      let m = this.$moment(timeStr, "HH:mm");

      let minutes = m.minutes();
      let rounded = Math.round(minutes / 15) * 15;

      m.minutes(rounded).seconds(0);

      return m.format("HH:mm");
    },
    formValidation() {
      this.errors = {};

      // Task name and date validations
      if (!this.form.F1) this.errors.F1 = 'この項目は必須です。';
      if (!this.form.greenc_task_id) this.errors.greenc_task_id = 'この項目は必須です。';
      if (!this.form.task_date) this.errors.task_date = 'この項目は必須です。';
      if (!this.form.user_id) this.errors.user_id = 'この項目は必須です。';
      if (!this.form.bill_id) this.errors.bill_id = 'この項目は必須です。';
      if (!this.form.greenc_child_task_work_type_id) this.errors.greenc_child_task_work_type_id = 'この項目は必須です。';
      if (!this.form.greenc_mst_status_type_id) this.errors.greenc_mst_status_type_id = 'この項目は必須です。';
      if (!this.form.work_type_id) this.errors.work_type_id = 'この項目は必須です。';
      if (!this.form.work_time_type_id) this.errors.work_time_type_id = 'この項目は必須です。';

      // Start time & End time validations
      if (this.form.start_time === null || this.form.start_time === undefined || this.form.start_time === '') {
        this.errors.start_time = '開始時間は必須です。';
      }
      if (this.form.end_time === null || this.form.end_time === undefined || this.form.end_time === '') {
        this.errors.end_time = '完了時間は必須です。';
      }

      let startM = null;
      let endM = null;

      if (this.form.start_time && this.form.end_time) {
        const [sh, sm] = this.form.start_time.split(':').map(Number);
        const [eh, em] = this.form.end_time.split(':').map(Number);

        startM = sh * 60 + sm;
        endM = eh * 60 + em;

        if (startM >= endM) {
          this.errors.start_time = '開始時間は完了時間より前である必要があります。';
          this.errors.end_time = '完了時間は開始時間より後である必要があります。';
        }
      }


      return Object.keys(this.errors).length > 0;
    },
    saveTask() {
      if (this.formValidation()) return;
      this.loading = true;
      const url = apiUrl + this.actl + '/' + this.saveUrl + '.json'
      const postData = this.preparePostData(this.form)
      console.log('postData', postData)
      this.$axios.post(url, postData)
          .then(response => {
            console.log('response', response)
            const responseData = response.data.response
            if (response.status === 200 && responseData.status === true) {
              const taskData = this.prepareTaskData(responseData.data)
              if (taskData.task_date === this.selectedStartDate) {
                this.tasks.push(taskData)
              }
            }else {
              this.apiErrorMsg = responseData.msg
            }
          })
          .catch(error => {
            console.log('error', error)
          })
          .finally(() => {
            this.loading = false;
            this.showDialog = false;
            this.form = {};
            this.loadData()
          })

    },
    prepareTaskData(data) {
      const normalizeTime = (val) => {
        if (!val) return '';
        const match = val.match(/T(\d{2}:\d{2})/);
        return match ? match[1] : val;
      };
      if (data) {
        return {
          id: data.id,
          name: data.F1,
          F1: data.F1,
          user_name: data.user ? data.user.username : '',
          task_date: this.$moment(data.task_date).format('YYYY-MM-DD'),
          start_time: normalizeTime(data.start_time),
          end_time: normalizeTime(data.end_time),
          bill_id: data.bill_id,
          greenc_child_task_work_type_id: data.greenc_child_task_work_type_id,
          greenc_child_task_work_type_name: data.greenc_child_task_work_type ? data.greenc_child_task_work_type.name : '',
          work_type_id: data.work_type_id,
          work_time_type_id: data.work_time_type_id,
          bill_name: data.bill ? data.bill.name : '',
          user_id: data.user_id,
          greenc_mst_status_type_id: data.greenc_mst_status_type_id,
          greenc_task_id: data.greenc_task_id,
          greenc_task_name: data.greenc_task ? data.greenc_task.F1 : '',
          category_id: data.bill_id,
        }
      }
      return {}
    },
    updateTask(fromDraggedMethod = false) {
      if (this.formValidation()) return;
      this.loading = true;
      const idx = this.tasks.findIndex(t => t.id === this.form.id);
      if (idx !== -1 && this.form.id) {
        const url = apiUrl + this.actl + '/' + this.editUrl + '/' + this.form.id + '.json'
        const postData = this.preparePostData(this.form)
        console.log('postData', postData)

        this.$axios.post(url, postData)
            .then(response => {
              console.log('response', response)
              const responseData = response.data
              if (response.status === 200) {
                const updatedTask = this.prepareTaskData(responseData.greencTask);
                // Preserve id and ensure reactivity by using splice
                if (!fromDraggedMethod) {
                  this.tasks.splice(idx, 1, { ...this.tasks[idx], ...updatedTask });
                }
              }else {
                this.apiErrorMsg = responseData.msg
              }
            })
            .catch(error => {
              console.log('error', error)
            })
            .finally(() => {
              this.loading = false;
              this.showDialog = false;
              this.form = {};
              if (!fromDraggedMethod) {
                this.loadData()
              }
              // this.loadData()
            })
      } else {
        this.apiErrorMsg = 'タスクが見つかりません。';
      }
    },
    deleteTask(taskId) {
      if (!confirm('このタスクを削除してもよろしいですか?')) return;
      this.loading = true;
      const idx = this.tasks.findIndex(t => t.id === taskId);
      if (idx !== -1) {
        const url = apiUrl + this.actl + '/' + this.deleteUrl + '/' + taskId + '.json'
        this.$axios.delete(url)
            .then(response => {
              const responseData = response.data.response
              if (response.status === 200 && responseData.status === true) {
                this.tasks.splice(idx, 1);
              }else {
                this.apiErrorMsg = responseData.msg
              }
            })
            .catch(error => {
              console.log('error', error)
            })
            .finally(() => {
              this.loading = false;
              this.showDialog = false;
              this.form = {};
              this.loadData()
            })
      } else {
        this.apiErrorMsg = 'タスクが見つかりません。';
      }
    },
    preparePostData(formData) {
      this.form.F1 = formData.F1
      return this.form
    },
    updateDraggedTask(task) {
      // When a bar is dragged/resized, update the task in our list
      const idx = this.tasks.findIndex(t => t.id === task.id);
      if (idx !== -1) {
        this.tasks.splice(idx, 1, { ...this.tasks[idx], ...task });
      }
      this.$nextTick(() => {
        Object.assign(this.form, task)
        this.updateTask(true)
      })
    },
    goToGanttChartHome() {
      this.$router.push('/')
    },
    nextDate() {
      const base = this.selectedStartDate ? this.$moment(this.selectedStartDate, 'YYYY-MM-DD') : this.$moment();
      this.selectedStartDate = base.add(1, 'day').format('YYYY-MM-DD');
      this.$router.push('/gantt-chart-by-time/' + this.selectedStartDate)
    },
    prevDate() {
      const base = this.selectedStartDate ? this.$moment(this.selectedStartDate, 'YYYY-MM-DD') : this.$moment();
      this.selectedStartDate = base.subtract(1, 'day').format('YYYY-MM-DD');
      this.$router.push('/gantt-chart-by-time/' + this.selectedStartDate)
    }
  },
}
</script>

<style scoped>
.base { position: fixed; top: 0; left: 0; right: 0; display: flex; justify-content: center; margin-top: 50px; }
.overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: gray; opacity: 0.5; }
.content { background-color: white; position: relative; border-radius: 10px; padding: 40px; }
.spinner-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 9999; display: flex; justify-content: center; align-items: center; }
.spinner { border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 2s linear infinite; }
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
</style>